<template>
  <div class="loginControllers">
    <loading-full-page :active="!initialize&&authUser&&!authUser.relation&&authUser.responce!='NG'" image-type="hexagram" image-text="アカウント情報確認中です"></loading-full-page>
    <app-loading class="loginControllers__loading" :isLoading="isLoading"></app-loading>
    <h1 class="loginControllers__title">ログイン</h1>
    <Attention v-if="errorMessage" :text="errorMessage"/>
    <form-input
      v-model="email"
      type="email"
      name="email"
      placeholder="例）uranaitv@uranai.tv"
      label="メールアドレス"
      :validation="{ rules: {
        required: true,
        nonRfcEmailCheck: true,
        email: false
        } }"
    />
    <form-password
      v-model="password"
      name="password"
      placeholder=""
      label="パスワード"
      :autosave="false"
      :validation="{ rules: {
        required: true
        } }"
      :strength-meter="false"
    />
    <div class="loginControllers__passForget">
      <a href="/user/password">パスワードをお忘れですか？</a>
    </div>
    <BaseButton class="loginControllers__button"
      label="ログイン"
      :is-disabled="buttonIsDisabled"
      @clicked="login"/>
    <div class="loginControllers__sns">
      <p class="loginControllers__sns__title">SNSアカウントでログイン</p>
      <sns-register
        register-type="signin"
        :registToken="registToken"
        :hidden-relation="authUser.relation"
      ></sns-register>
    </div>
    <div class="loginControllers__new">
      アカウント登録がまだの方は<a href="/user/input">こちら</a>から
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import login from './login'
import Attention from './common/Attention'
import BaseButton from './common/BaseButton'

export default {
  name: 'loginControllers',
  mixins: [login],
  components:{
    Attention,
    BaseButton
  },
  data() {
    return {
      fromPage: this.getParam('show'),
      validateFlags: {},
      buttonIsDisabled: true,
      isSubscRegistering: false,
    }
  },
  props: {
    registToken: { type: String, default: ''},
    returnPath: { type: String, default: '' },
    initialize: { type: Boolean, default: false },
    isIdentification: { type: Boolean, default: false}
  },
  computed: {
    ...mapState({
      authUser: state => state.auth.data
    })
  },
  beforeMount() {
    if(this.initialize){
      this.$store.dispatch(type.RESET_REGISTRATION_BY_FIREBASE_UID)
    }
  },
  created() {
    this.checkQueryParam()
  },
  mounted() {
    if (this.isIdentification && this.registToken) {
      this.registrationWithCustomToken()
    }
    this.validateFlags = this.$validator.flags
    this.isSubscRegistering = /subsc_regist=1/.test(location.search)
  },
  watch:{
    validateFlags: {
      handler(n) {
        this.buttonIsDisabled = n.email.invalid || n.password.invalid
      },
      deep: true
    }
  },
  methods: {
    getParam(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      var prm = results[2].replace(/\+/g, " ").split('?');
      return decodeURIComponent(prm[0]);
    },
    registrationWithCustomToken() {
      firebase.auth().signInWithCustomToken(this.registToken).then( result => {
        const data = {
          nickname: result.user.displayName,
          email: result.user.email,
          uid: result.user.uid,
          sns: 'line',
          cpno: this.cpno
        }
        this.registrationByFirebaseUid(data)
      }).catch(error => {
        console.log(error)
      })
    },
    // クエリパラメーターのチェック
    checkQueryParam() {
      const str = location.search.slice(1)
      // 登録済みでエラーの場合
      if (/error=is_registed/.test(str)) {
        // クエリパラメーターの sns を取得する
        const arr = str.split('&')
        let sns = arr.find(elem => /sns=/.test(elem))
        sns = sns ? sns.split('=')[1] : ''
        if (sns === 'line') sns = 'LINEに'
        else if (sns === 'twitter') sns = 'Twitterに'
        // エラーメッセージ
        this.errorMessage = `${sns}登録されているメールアドレスで既に会員登録をされています。`
      }
    },
  }
}</script>

<style lang="scss">
@import "../../../sass/commons/commonVariables.scss";

.loginControllers{
  padding: 30px 14px 60px;

  &__title{
    color: $col_base_black;
    font-size: 21px;
    line-height: 31px;
    text-align: center;
    margin-bottom: 30px;
  }

  &__passForget{
    text-align: right;
    margin-top: -14px;
    a{
      font-size: 11px;
      color: $col_normal_font;
    }
  }

  &__button{
    margin: 40px auto;
    width: fit-content;
  }

  &__sns{
    &__title{
      font-size: 13px;
      line-height: 19px;
      text-align: center;
      display: flex;
      align-items: center;
    }

    &__title:before,
    &__title:after {
      content: "";
      flex-grow: 1;
      height: 1px;
      background: $col_temp_gray2;
      display: block;
    }
    &__title:before {
      margin-right: 0.6em;
    }
    &__title:after {
      margin-left: 0.6em;
    }
  }

  &__new{
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: $col_temp_black;
    margin-top: 35px;
  }

  &__loading {
    position: absolute;
    z-index: 3;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/LoginControllers.vue